module.exports = __webpack_public_path__ + "img/gaoxinqiye.e5de2a4a.webp";